<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page mini-jeux">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">

          <div v-if="currentUser.account_type === 'child'">
            <title-page attrpage="Ton parcours de soin" baseline="">Mini-jeux</title-page>
            <p>Voici les mini-jeux débloqués spécialement pour toi ! </br>Avant d’y jouer, tu peux lire les explications sur le soin ou l’examen qu’on va te faire pour mieux comprendre. N’hésite jamais à poser des questions au personnel soignant ou tes parents.</p>
          </div>

          <div v-else-if="currentUser.account_type === 'parent'">
            <title-page attrpage="Le parcours de soin" baseline="">Mini-jeux</title-page>
            <p>Retrouvez ici les mini-jeux pour accompagner {{ childName }} dans son parcours de soins et son quotidien.</br>Les mini-jeux sont débloqués en fonction des rendez-vous saisis dans le calendrier.</p>
          </div>

          <div class="road-game">

            <template v-if="currentUser.account_type === 'caregiver'">
              <game-item v-for="game, number in ['chimio', 'transfusion', 'myelogramme', 'decouverte', 'voie-veineuse', 'conditionnement', 'catheter']" :number="number + 1" :game="{game, score: 0, id: 0}" />
            </template>
            <template v-else>
              <div v-if="games.length === 0" class="box-mascotte">
                <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>

                <div class="bubble left txtleft">
                  <div v-if="currentUser.account_type === 'child'">Actuellement tu peux jouer au jeu de bienvenue pour découvrir la plateforme, dès que tu auras ton prochain rendez-vous tu pourras revenir sur cette page voir un nouveau jeu.</div>
                  <div v-if="currentUser.account_type === 'parent'">Actuellement {{ childName }} a seulement le jeu de "bienvenue" qui est disponible, une fois le prochain rendez-vous enregistré vous pourrez revenir sur cette page découvrir le jeu débloqué.</div>
                </div>
                <div class="dot end"></div>
              </div>
              <template v-else>
                <div class="box-mascotte">
                  <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>

                  <div class="bubble left txtleft">
                    <div v-if="currentUser.account_type === 'child'">Lance le prochain jeu débloqué en vert </div>
                    <div v-if="currentUser.account_type === 'parent'">Testez le mini-jeu auquel {{ childName }} va jouer.</div>
                  </div>

                  <div class="dot end"></div>
                </div>
                <game-item v-for="game, id in games" :number="id + 1" :game="game" />
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import GameItem from '@/components/GameItem'
  import { mapGetters, mapState } from 'vuex'
  export default {
    components: { TitlePage, GameItem },
    computed: {
      games () {
        return this.$store.state.me.games.slice().reverse();
      },
      ...mapGetters(['childName']),
      ...mapState(['notifications']),
      currentUser() {
        return this.$store.state.me
      }
    },
    async mounted () {
      if (this.currentUser.account_type === 'parent' || this.currentUser.account_type === 'caregiver') {
        if (this.notifications.findIndex(n => n.notification_type === 'minigame_survey_completed') === -1) {
          await this.$store.dispatch('addAnnouncement', { layout: 'survey', cta: '/sondage/RTK781', message:
            `Votre avis sur les mini-jeux nous intéresse. Pourriez-vous répondre à quelques questions ?`
          })
        }
      }
    }
  }
</script>

